export default function ElementMixerIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#1B2A6B" />
      <circle cx="18" cy="18" r="11" fill="#FF6A2B" />
      <path d="M18 10C21 14 24 16 22 21C21 24 15 24 14 21C13 17 17 15 18 10Z" fill="#FFD23F" />
      <circle cx="46" cy="18" r="11" fill="#2F8BFF" />
      <path d="M46 10C50 16 52 19 50 22C48 25 44 25 42 22C40 19 42 16 46 10Z" fill="#BFE6FF" />
      <path d="M26 30L32 36L38 30" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="32" cy="48" r="13" fill="#fff" />
      <path d="M26 54C26 46 32 44 32 38C34 44 39 46 38 54Z" fill="#9AA3AD" />
      <path d="M30 41C31 39 33 39 34 41" stroke="#5FD3A3" strokeWidth="2" fill="none" />
      <circle cx="12" cy="44" r="2" fill="#FFD23F" />
      <circle cx="54" cy="40" r="2.5" fill="#FFD23F" />
      <circle cx="50" cy="54" r="1.6" fill="#FFD23F" />
    </svg>
  );
}
